import { createApiCall } from 'lib/base';

const RESET_STAFF_ACCOUNT_TWO_FACTOR = 'RESET_STAFF_ACCOUNT_TWO_FACTOR';

// Turns off 2FA for a staff member who lost their authenticator device
// (admin/superadmin only).
export const resetStaffAccountTwoFactorApi = createApiCall<{ id: string }>(
  RESET_STAFF_ACCOUNT_TWO_FACTOR,
  ({ id }) => ({
    endpoint: `api/admin/staff-accounts/${id}/reset-two-factor`,
    method: 'POST',
  })
);

export default resetStaffAccountTwoFactorApi;
